import styled, { css } from "styled-components";

export const ContentWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 98px;
`;

export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ContentContainer = styled.div`
  position: fixed;
  width: 100%;
`;

export const MainArea = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  position: relative;
`;

export const MainBody = styled.main`
  overflow-y: auto;
  overflow-x: hidden;
  bottom: 0;
  right: 0;
  left: 270px;
  top: 5px;
  position: absolute;
  transition: left 0.3s;
  width: calc(100% - 270px);
  max-width: calc(100% - 270px);
`;

export const chartStyling = css`
  border: none;
`;
